import { SkippyLinks } from './SkippyLinks.js';
window.customElements.define('skippy-links', SkippyLinks);
//# sourceMappingURL=skippy-links.js.map